import { authApiService } from '@/api/authApiService';

export const deletePaymentDetailsApi = (wireId: string) => {
  const uri = `/organization/wires/${wireId}/payment-details/`;

  return authApiService.DELETE(uri);
};
